<template>
  <div id="leaseDetail" class="dashboard-editor-container">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span style="font-size: 18px;">{{ $t('lease.machineSN') }}：{{ basicinfo.deviceSn }}</span>
        <span v-show="basicinfo.yhubSn" class="fontStyle2" />
        <span v-show="basicinfo.yhubSn" style="font-size: 18px;">
          SN：
          <el-link type="primary" @click="goToDetailgPage">
            {{ basicinfo.yhubSn }}
          </el-link>
          <span class="fontStyle2" />
          <span style="font-size: 20px;margin-right: 20px;">{{ $t('dashboard.DeviceName') }}：{{ basicinfo.deviceName }}</span>
        </span></div>
    </el-row>
    <!-- 总计 -->
    <el-row :gutter="40" style="margin-top: 32px;" class="totalWarp">
      <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col col1">
        <div class="card-panel" style="padding:10px 20px 0">
          <i class="el-icon-time totalI" />
          <span class="totalP">{{ $t('lease.TotalRentedDays') }}</span>
          <span class="totalTimeAndMoneyP">{{ basicinfo.totalDays }}</span>
        </div>
      </el-col>
      <!-- 竖线 -->
      <el-col class="lineCol">
        <div class="lineDiv" />
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col col2">
        <div class="card-panel" style="padding: 10px 20px 0;position:relative;">
          <i class="el-icon-bangzhu totalI" />
          <span class="totalP">{{ $t('lease.TotalIncome') }}</span>
          <span class="totalTimeAndMoneyP">{{ basicinfo.totalCost }}</span>
        </div>
        <!-- <div class="totalBtnWarp">
          <el-button v-show="basicinfo.yhubSn" type="primary" icon="el-icon-view" @click="goToDetailgPage" />
          <el-button v-if="!relayStatus" type="primary" icon="el-icon-loading" />
          <el-button v-if="relayStatus=='on'" type="primary" @click="openLockCar">解锁</el-button>
          <el-button v-if="relayStatus=='off'" type="primary" @click="isShowCloseCarPop=true">锁车</el-button>
          <div class="headContentQuestion" @mouseover="isShowQuestionPop=true" @mouseout="isShowQuestionPop=false">
            <div class="el-icon-question" />
          </div>
        </div> -->
      </el-col>
      <!-- 选项卡处的问号--弹窗 -->
      <div v-show="isShowQuestionPop" class="questionPop">
        <p style="max-width: 310px;font-size:14px;">
          {{ $t('lease.EditRemot') }}
          <span style="color:#1990fc;">{{ $t('lease.deviceTo1') }}</span>
          <i style="color:#1990fc;" class="el-icon-unlock" />
          <span style="color:#1990fc;">{{ $t('lease.deviceTo2') }}</span>
          {{ $t('lease.no') }}
        </p>
      </div>
    </el-row>

    <!-- 锁车--弹窗 -->
    <el-dialog id="closeCarPopId" :close-on-click-modal="false" :visible.sync="isShowCloseCarPop" width="50%">
      <el-form ref="closeCarPop" :model="closeCarPopData" label-position="right" label-width="180px" :inline="false" :rules="closeCarPopRule">
        <el-form-item :label="$t('lease.Reason')" prop="cause">
          <el-input v-model="closeCarPopData.cause" type="textarea" style="width: 100%" :autosize="{ minRows: 4, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('yhubReport.Date')" prop="deviceSnPop" class="deviceSnPop redStart">
          <el-date-picker v-model="closeCarPopData.selectDay" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch(closeCarPopData.selectDay,'closeCarPop')" />
          <p v-show="isShowTimeCloseCarWarn" class="redWarningFont">{{ $t('lease.SelectDate') }}</p>
        </el-form-item>
        <el-form-item :label="$t('lease.Person')" prop="operator">
          <el-input v-model="closeCarPopData.operator" @input="change($event)" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowCloseCarPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmCloseCarPop('closeCarPop')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!-- 出租记录 -->
    <el-row class="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- 出租列表 -->
        <div style="position: relative;padding:10px 20px 20px;color: #858585;font-weight: 700;">
          <span style="display: inline-block;margin-bottom: 20px;">{{ $t('lease.Rentalrecords') }}</span>
          <div v-if="$store.state.userInfo.guestFlag!=true" style="float: right;margin:-10px  0 10px;">
            <!-- <el-button :disabled="isDisabledRentAddBtn" type="primary" icon="el-icon-plus" @click="addRentPop" /> -->
            <el-button type="primary" icon="el-icon-plus" @click="addRentPop" />
            <el-button v-if="!relayStatus" type="primary" icon="el-icon-loading" />
            <el-button v-if="relayStatus=='on'" type="primary" @click="openLockCar">{{ $t('lease.Unlock') }}</el-button>
            <el-button v-if="relayStatus=='off'" type="primary" @click="isShowCloseCarPop=true">{{ $t('lease.Lock') }}</el-button>
            <div class="headContentQuestion" @mouseover="isShowQuestionPop=true" @mouseout="isShowQuestionPop=false">
              <div class="el-icon-question" />
            </div>
          </div>
          <el-table :data="rentTableData" style="width: 100%;padding:2px;" border>
            <el-table-column prop="customerName" :label="$t('lease.Customer')" />
            <el-table-column prop="startAndEndTime" :label="$t('lease.Startandenddate')" />
            <el-table-column prop="days" :label="$t('lease.duration')" />
            <el-table-column prop="cost" :label="$t('lease.Income')" />
            <el-table-column prop="remark" :label="$t('warningPage.Remark')" />
            <el-table-column :label="$t('AllDevices.Status')">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p v-if="scope.row.status==1">{{ $t('lease.Valid') }}</p>
                  <p v-else>{{ $t('lease.Invalid') }}</p>
                  <!-- <p v-else>{{ $t('lease.Expired') }}</p> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="action" :label="$t('yhubReport.Operating')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <!-- <el-button type="primary" icon="el-icon-edit" :disabled="scope.row.status!=1" size="mini" @click="editRentPop(scope.row)" /> -->
                  <el-button v-if="$store.state.userInfo.guestFlag!=true" type="primary" icon="el-icon-edit" size="mini" @click="editRentPop(scope.row)" />
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination
                v-if="pageshow"
                background
                current-page.sync="rentListQuery.pageInfo.page"
                :page-sizes="rentListQuery.pageInfo.pageList"
                :page-size="rentListQuery.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="rentListQuery.pageInfo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 新增/编辑--出租记录--弹窗 -->
    <el-dialog id="rentPopId" :close-on-click-modal="false" :visible.sync="isShowRentPop" width="50%">
      <el-form ref="rentPop" :model="rentPopData" label-position="right" label-width="180px" :inline="false" :rules="rentPopRule">
        <el-form-item :label="$t('AllDevices.Status')">
          <el-switch v-model="rentPopData.status" :active-text="$t('lease.Valid')" :inactive-text="$t('lease.Invalid')" @change="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('lease.Customer')" prop="customerName">
          <el-input v-model="rentPopData.customerName" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('lease.Startandenddate')" prop="deviceSnPop" class="deviceSnPop redStart">
          <el-date-picker v-model="rentPopData.selectDay" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch(rentPopData.selectDay,'rentPop')" />
          <p v-show="isShowTimeRendWarn" class="redWarningFont">{{ $t('lease.Selectstartdate') }}</p>
        </el-form-item>
        <el-form-item :label="$t('lease.amount')" prop="cost">
          <el-input v-model="rentPopData.cost" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')" prop="mm">
          <el-input v-model="rentPopData.remark" type="textarea" style="width: 100%" :autosize="{ minRows: 4, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowRentPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmRentPop('rentPop')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!-- 保养记录 -->
    <el-row class="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- 保养列表 -->
        <div style="position: relative;padding:10px 20px 20px;">
          <span style="display: inline-block;margin-bottom: 20px;color: #858585;font-weight: 700;">{{ $t('lease.Maintenancerecord') }}</span>
          <el-button v-if="$store.state.userInfo.guestFlag!=true" type="primary" icon="el-icon-plus" style="vertical-align: top;margin: -10px 10px 10px;float: right;position: relative;z-index: 999;" @click="addMainPop" />
          <el-table :data="maintainTableData" style="width: 100%;padding:2px;" border>
            <el-table-column prop="myMaintainTime" :label="$t('lease.Content')" />
            <el-table-column prop="maintainContent" :label="$t('yhubReport.Date')" />
            <el-table-column prop="maintainer" :label="$t('lease.Person2')" />
            <el-table-column prop="remark" :label="$t('warningPage.Remark')" />
            <el-table-column prop="action" :label="$t('yhubReport.Operating')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <el-button v-if="$store.state.userInfo.guestFlag!=true" type="primary" icon="el-icon-edit" size="mini" @click="editMainPop(scope.row)" />
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination
                v-if="pageshow2"
                background
                current-page.sync="maintainListQuery.pageInfo.page"
                :page-sizes="maintainListQuery.pageInfo.pageList"
                :page-size="maintainListQuery.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="maintainListQuery.pageInfo.total"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 新增/编辑--保养记录--弹窗 -->
    <el-dialog id="mainPopId" :close-on-click-modal="false" :visible.sync="isShowMainPop" width="50%">
      <el-form ref="mainPop" :model="mainPopData" label-position="right" label-width="180px" :inline="false" :rules="mainPopRule">
        <el-form-item :label="$t('yhubReport.Date')" prop="deviceSnPop" class="deviceSnPop redStart">
          <el-date-picker v-model="mainPopData.selectDay" type="date" :placeholder="$t('lease.SelectDate')" @change="changeSearch(mainPopData.selectDay,'mainPop')" />
          <!-- <el-date-picker v-model="mainPopData.selectDay" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch(rentPopData.selectDay,'rentPop')" /> -->
          <p v-show="isShowTimeMainWarn" class="redWarningFont">{{ $t('lease.SelectDate') }}</p>
        </el-form-item>
        <el-form-item :label="$t('lease.Content')" prop="maintainContent">
          <el-input v-model="mainPopData.maintainContent" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('lease.Person2')" prop="maintainer">
          <el-input v-model="mainPopData.maintainer" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')" prop="mm">
          <el-input v-model="mainPopData.remark" type="textarea" style="width: 100%" :autosize="{ minRows: 4, maxRows: 8}" @input="change($event)" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowMainPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmMainPop('mainPop')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findRentalDeviceById, findRentalDeviceDetailList, findRentalDeviceMaintainList, addRentalDeviceDetail, updateRentalDeviceDetail, addRentalDeviceMaintain, updateRentalDeviceMaintain, findLockCarDetailById, unLockCar, addLockCarDetail, updateLockCarDetailStatus, GetRealTimeData } from '@/api/leaseManagement'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'

export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      basicinfo: {
        deviceSn: this.$route.query.deviceSn,
        deviceName: this.$route.query.deviceName
      },
      isShowQuestionPop: false,
      rentTableData: [],
      maintainTableData: [],
      isShowRentPop: false,
      rentPopData: {
        customerName: '',
        selectDay: [],
        cost: '',
        remark: '',
        isAdd: true
      },
      rentPopRule: {
        cost: [{ required: true, message: i18n.t('lease.Enteramount'), trigger: 'blur' }] // 序列号不能为空
        // deviceNamePop: [{ required: true, message: i18n.t('BondOrUpdateDevice.PleaseEnterAName'), trigger: 'blur' }] // 设备名称不能为空
      },
      isShowTimeRendWarn: false,
      isDisabledRentAddBtn: true,
      isShowMainPop: false,
      isShowTimeMainWarn: false,
      mainPopData: {
        maintainContent: '',
        selectDay: '',
        maintainer: '',
        remark: '',
        isAdd: true
      },
      mainPopRule: {
        maintainContent: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }] // 序列号不能为空
      },
      yhubmqtt: {},
      relayStatus: null,
      isShowCloseCarPop: false,
      isShowTimeCloseCarWarn: false,
      closeCarPopData: {
        cause: '',
        selectDay: [],
        operator: ''
      },
      closeCarPopRule: {
        cause: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }],
        operator: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }]
      },
      // 分页----start
      rentListQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      // 分页----start
      maintainListQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow2: true
      // 分页----end
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.mqttMSG()
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    this.queryRentList()
    this.queryMaintainList()
    this.queryLockCar()
    this.$nextTick(() => {
      this.mqttMSG()
    })
  },
  created() {
    this.query()
  },
  methods: {
    query() { // 基本信息
      this.basicinfo.yhubSn = this.$route.query.yhubSn
      findRentalDeviceById({ id: this.$route.query.id }).then(res => {
        this.basicinfo = res.resultModel
        // this.basicinfo.deviceType = res.resultModel.deviceType
        // this.basicinfo.mcuId = res.resultModel.mcuId
        // this.basicinfo.totalDays = res.resultModel.totalDays
        // this.basicinfo.totalCost = res.resultModel.totalCost
        GetRealTimeData({ mcuId: this.basicinfo.mcuId }).then(res => {})
      })
    },
    openLockCar() { // 开锁
      this.$confirm('是否将车辆解锁？', '', {//
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        unLockCar({ 'yhubSn': this.$route.query.yhubSn }).then(res => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: i18n.t('lease.Machineunlocked') // 解锁成功
            })
          }
        })
      }).catch(() => {})
    },
    confirmCloseCarPop(formName) { // 锁车--提交
      var param = {
        'cause': this.closeCarPopData.cause,
        'endTime': 1601179375,
        'operator': this.closeCarPopData.operator,
        'remark': 'string',
        'startTime': 1582776175,
        'yhubSn': this.$route.query.yhubSn
      }
      // console.log(this.closeCarPopData.selectDay)
      console.log(param)
      if (this.closeCarPopData.selectDay && this.closeCarPopData.selectDay.length > 0) {
        param.startTime = Math.round((new Date(this.closeCarPopData.selectDay[0]).setHours(0, 0, 0, 0)) / 1000)
        param.endTime = Math.round((new Date(this.closeCarPopData.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1) / 1000)
        if (param.endTime < Math.round((new Date().getTime()) / 1000)) {
          this.$message({
            type: 'error',
            message: i18n.t('location.endDateThanToday')// '结束日期不能早于当前日期！'
          })
          return
        }
      } else {
        this.isShowTimeCloseCarWarn = true
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addLockCarDetail(param).then(res => {
            if (res.resultCode == 1001) {
              this.isShowCloseCarPop = false
              this.$message({
                type: 'success',
                message: i18n.t('lease.Machinelocked')// 锁车成功
              })
            }
          })
        }
      })
    },
    mqttMSG() {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.basicinfo.mcuId) == -1) return
        console.log('收到数据======', this.yhubmqtt)
        if (this.yhubmqtt.payload === 'mRealTimeData') {
          // console.log('myMqtt---', this.yhubmqtt)
          if (!this.yhubmqtt.mRealTimeData) return
          if (this.yhubmqtt.mRealTimeData.relayStatus) { // 锁车
            this.relayStatus = 'on'
            updateLockCarDetailStatus({ 'status': 2, 'yhubSn': this.$route.query.yhubSn }).then(res => {

            })
          } else { // 未锁车
            this.relayStatus = 'off'
          }
        }
        this.msg = this.yhubmqtt
      }
    },
    queryRentList() { // 出租记录
      var param1 = {
        'pageNum': this.rentListQuery.pageInfo.pageNum,
        'pageSize': this.rentListQuery.pageInfo.pageSize,
        'rentalDeviceId': this.$route.query.id
      }
      findRentalDeviceDetailList(param1).then(res => {
        this.rentListQuery.pageInfo.total = res.resultModel.total // 分页
        this.rentTableData = res.resultModel.list
        console.log(this.rentTableData)
        this.rentTableData.forEach((v, i) => {
          if (v.startTime && v.endTime) {
            v.startAndEndTime = getDateAndHour(v.startTime, 'noTime') + ' - ' + getDateAndHour(v.endTime, 'noTime')
          }
          // v.myStatus = v.status == 1 ? '有效' : '过期'
          // v.myStatus = v.status
        })
        console.log(this.rentTableData)

        this.isDisabledRentAddBtn = this.rentTableData.some(v => {
          return v.status == 1
        })
        console.log(this.isDisabledRentAddBtn)
      })
    },
    queryMaintainList() { // 保养记录
      var param1 = {
        'pageNum': this.maintainListQuery.pageInfo.pageNum,
        'pageSize': this.maintainListQuery.pageInfo.pageSize,
        'rentalDeviceId': this.$route.query.id
      }
      findRentalDeviceMaintainList(param1).then(res => {
        this.maintainListQuery.pageInfo.total = res.resultModel.total // 分页
        this.maintainTableData = res.resultModel.list

        this.maintainTableData.forEach((v, i) => {
          if (v.maintainTime) {
            v.myMaintainTime = getDateAndHour(v.maintainTime, 'noTime')
          }
        })
      })
    },
    addRentPop() { // 添加出租记录弹窗--新增
      this.isShowRentPop = true
      this.rentPopData = {}
      this.rentPopData.isAdd = true
    },
    editRentPop(row) { // 添加出租记录弹窗--编辑
      this.isShowRentPop = true
      if (row.status == 1) { this.rentPopData.status = true } else { this.rentPopData.status = false }
      if (row.customerName) this.rentPopData.customerName = row.customerName
      if (row.startTime && row.endTime) {
        this.rentPopData.selectDay[0] = row.startTime
        this.rentPopData.selectDay[1] = row.endTime
      }
      if (row.cost) this.rentPopData.cost = row.cost
      if (row.remark) this.rentPopData.remark = row.remark
      if (row.id) this.rentPopData.id = row.id
      this.rentPopData.isAdd = false
    },
    confirmRentPop(formName) { // 添加出租记录弹窗--提交
      var param = {
        'cost': this.rentPopData.cost,
        'customerName': this.rentPopData.customerName,
        'days': 100,
        'endTime': 1601179375000,
        'remark': this.rentPopData.remark,
        'rentalDeviceId': this.$route.query.id,
        'startTime': 1582776175042,
        'id': this.rentPopData.id || ''
      }
      if (this.rentPopData.selectDay && this.rentPopData.selectDay.length > 0) {
        param.startTime = new Date(this.rentPopData.selectDay[0]).setHours(0, 0, 0, 0)
        param.endTime = new Date(this.rentPopData.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
        param.days = Math.ceil((param.endTime - param.startTime) / (24 * 60 * 60 * 1000))
        if (param.endTime < new Date().getTime()) {
          this.$message({
            type: 'error',
            message: i18n.t('location.endDateThanToday')// '结束日期不能早于当前日期！'
          })
          return
        }
      } else {
        this.isShowTimeRendWarn = true
        return
      }
      console.log(param)
      if (this.rentPopData.status) { param.status = 1 } else { param.status = 2 }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.rentPopData.isAdd) { // 新增
            addRentalDeviceDetail(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowRentPop = false
                this.queryRentList()
              }
            })
          } else {
            updateRentalDeviceDetail(param).then(res => {
              this.isShowRentPop = false
              this.queryRentList()
            })
          }
        }
      })
    },
    addMainPop() { // 添加保养记录弹窗--新增
      this.isShowMainPop = true
      this.mainPopData = {}
      this.mainPopData.isAdd = true
    },
    editMainPop(row) { // // 添加保养记录弹窗--编辑
      this.isShowMainPop = true
      if (row.maintainTime) {
        this.mainPopData.selectDay = row.maintainTime
      }
      if (row.remark) this.mainPopData.remark = row.remark
      if (row.maintainContent) this.mainPopData.maintainContent = row.maintainContent
      if (row.maintainer) this.mainPopData.maintainer = row.maintainer
      if (row.id) this.mainPopData.id = row.id
      this.mainPopData.isAdd = false
    },
    confirmMainPop(formName) { // 添加保养记录弹窗--提交
      var param = {
        'maintainContent': this.mainPopData.maintainContent,
        'maintainTime': null,
        'maintainer': this.mainPopData.maintainer,
        'remark': this.mainPopData.remark,
        'rentalDeviceId': this.$route.query.id,
        'id': this.mainPopData.id || ''
      }
      if (this.mainPopData.selectDay) {
        param.maintainTime = new Date(this.mainPopData.selectDay).setHours(0, 0, 0, 0)
      } else {
        this.isShowTimeMainWarn = true
        return
      }
      console.log(param)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.mainPopData.isAdd) { // 新增
            addRentalDeviceMaintain(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowMainPop = false
                this.queryMaintainList()
              }
            })
          } else {
            updateRentalDeviceMaintain(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowMainPop = false
                this.queryMaintainList()
              }
            })
          }
        }
      })
    },
    changeSearch(value, name) {
      if (name == 'rentPop') {
        if (value) {
          this.isShowTimeRendWarn = false
        } else {
          this.isShowTimeRendWarn = true
        }
      } else if (name == 'mainPop') {
        console.log(value)
        // if (value) {
        //   this.isShowTimeRendWarn = false
        // } else {
        //   this.isShowTimeRendWarn = true
        // }
      } else if (name == 'closeCarPop') {
        if (value) {
          this.isShowTimeCloseCarWarn = false
        } else {
          this.isShowTimeCloseCarWarn = true
        }
      }
    },
    goToDetailgPage() { // 去详情页
      var routeData = this.$router.resolve({
        path: '/allDevices/allDeviceDetail',
        query: {
          mcuId: this.basicinfo.mcuId,
          deviceType: this.basicinfo.deviceType,
          sn: this.basicinfo.yhubSn
          // id: this.basicinfo.id
        }
      })
      window.open(routeData.href, '_self')
    },
    queryLockCar() {
      findLockCarDetailById({ yhubSn: this.$route.query.yhubSn }).then(res => {

      })
    },
    change(e) {
      this.$forceUpdate()
    },
    sortChange(column) { // order: descending(降序)/ascending(升序)/null
      // 后台：1:endTimeDesc/2:endTimeAsc
      console.log(column)
      if (column.order == 'descending') this.tableObj.order = 1
      if (column.order == 'ascending') this.tableObj.order = 2
      // this.tableObj.order = column.order
      this.queryList()
    },
    // 筛选改变事件
    // changeSearch(inputDevName) {
    //   // 去掉首尾空格
    //   if (this.tableObj.deviceName) this.tableObj.deviceName = this.tableObj.deviceName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
    //   if (this.tableObj.yhubSn) this.tableObj.yhubSn = this.tableObj.yhubSn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
    //   if (this.tableObj.customerName) this.tableObj.customerName = this.tableObj.customerName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
    //   this.rentListQuery.page = 1
    //   this.queryList()
    // },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.rentListQuery.pageInfo.pageSize = val
      this.queryRentList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.rentListQuery.pageInfo.pageNum = val
      this.queryRentList()
    },
    // 分页----end

    // 分页----start
    handleSizeChange2(val, e) { // 每一页的列表的行数 10 20 50
      this.maintainListQuery.pageInfo.pageSize = val
      this.queryMaintainList()
    },
    handleCurrentChange2(val, e) { // 选中某一页
      this.maintainListQuery.pageInfo.pageNum = val
      this.queryMaintainList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
#leaseDetail{
  height:100%;
  // background: #fff;
  .lineCol{
    padding:0!important;
    width:2px;
    height:80px;
  }
  .lineDiv{
    background:#ecedef;
    width:100%;
    height:100%;
  }
  .totalI{
    font-size: 32px;
  }
  .totalP{
    font-size: 28px;
    margin:0 20px 0 5px;
  }
  .totalTimeAndMoneyP{
    font-size: 34px;
    font-weight: bold;
  }
  .totalBtnWarp{
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
  .headTitle a{
    text-decoration: underline;
    color: blue;
  }
  .headContentQuestion{
    font-size: 22px;
    color: #a5a5a5;
    display: inline-block;
    vertical-align: top;
    margin: 7px 0 0 3px;
    cursor: pointer;
  }
  .questionPop{
    display: inline-block;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    right: 48px;
    top: 99px;
    line-height: 25px;
    // margin: -8px 30px 0 -240px;
    // width:30%;
  }
  .tableWarp{
    background: #fff;
    margin-top: 32px;
    padding-top: 20px;
  }

  ////////////////
  .statusDiv{
    width:100%;
    height: 20px;
    background:#f3f3f3;
    margin-top:2px;
  }
  .greenStatus{
    width: 33%;
    background: #43d043;
    height: 20px;
  }
  .yellowStatus{
    width: 66%;
    background: #f7f73f;
    height: 20px;
  }
  .redStatus{
    width: 100%;
    background: #fb2b2b;
    height: 20px;
  }
}
</style>
<style lang="scss">
#leaseDetail{
  .totalWarp{
    margin:32px 0 0!important;
    height: 150px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .card-panel-col{
      width:calc(50% - 1px);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .col1{
      padding-right:0!important;
    }
    .col2{
      padding-left:0!important;
    }
  }
  .el-date-editor.el-input__inner,.el-date-editor.el-input{
    width:100%!important;
  }
  //////
  .el-table th.gutter{
    display: table-cell!important;
  }
  #leasePopId{
    .el-autocomplete,.el-cascader--medium,.el-input,.deviceSnPop .el-select{
      width:80%!important;
    }
    .deviceSnPop .el-input{
      width:100%!important;
    }
  }
}
</style>
